import React from 'react'
import { Routes, Route } from 'react-router-dom'
import 'animate.css/animate.compat.css';

// page imports
import Home from './components/Home'; 
import About from './components/About';
// general imports
import ScrollTop from './general/ScrollTop';
import Header from './general/Header';
import Footer from './general/Footer';
import PageNotFound from './general/PageNotFound';
import Contact from './components/Contact';
import AdminLogin from './components/AdminLogin';
import { useLocation } from 'react-router-dom';
import AdminDashboard from './Admin/AdminDashboard';
import AdminHeader from './Admin/AdminHeader';
import Enquiry from './Admin/Enquiry';
import AddPackage from './Admin/AddPackage';
import TourPackage from './components/TourPackage';
import Bookings from './Admin/Bookings';

const App = () => {
 const location = useLocation();
const isAdminLogin = location.pathname === '/admin-login';
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  return (
    <>
            <ScrollTop />

        {!isLoggedIn && (
<>

{!isAdminLogin && 
<Header />
}
      <Routes>
        <Route exact path='/' element={<Home />} />
        <Route exact path='/about' element={<About />} />
        <Route exact path='/tour-packages' element={<TourPackage />} />
        <Route exact path='/contact' element={<Contact />} />
        <Route exact path='/admin-login' element={<AdminLogin />} />
        <Route exact path='*' element={<PageNotFound />} />
        </Routes>

        {!isAdminLogin && 
<Footer />
        }

        </>
        )}


                {isLoggedIn && (
          <>
            <AdminHeader isLoggedIn={isLoggedIn} />
            <Routes>
              <Route exact path='/' element={<AdminDashboard />} />
              <Route exact path='/dashboard' element={<AdminDashboard />} />
              <Route exact path='/site-enquiry' element={<Enquiry />} />
              <Route exact path='/add-package' element={<AddPackage />} />
              <Route exact path='/bookings' element={<Bookings />} />

              {/* <Route exact path='/admin/dashboard' element={<Dashboard />} />
              <Route exact path='/admin/enquiry' element={<Enquiry />} />
              <Route exact path='*' element={<PageNotFound />} /> */}
            </Routes>
          </>
        )}


    </>
  )
}

export default App
